import { useState, useEffect } from 'react'
import { api } from 'helpers'
import { ARC_MOSAICO_ENDPOINTS } from 'api/arcMosaico'
import { GradeLevel } from '../../../types'

/**
 * Response from /api/arc_mosaico/grades endpoint
 * Returns grades from current user's school active courses
 */
interface ArcGradeApiResponse {
  id: number
  name: string
}

interface UseArcGradesReturn {
  grades: GradeLevel[]
  loading: boolean
  error: string | null
}

/**
 * Hook to fetch grades from Arc Mosaico API /api/arc_mosaico/grades
 * Returns grades derived from the user's school active courses
 */
export const useArcGrades = (): UseArcGradesReturn => {
  const [grades, setGrades] = useState<GradeLevel[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchGrades = async () => {
      try {
        setLoading(true)
        const response = await api.get<ArcGradeApiResponse[]>(ARC_MOSAICO_ENDPOINTS.grades.list)

        const mappedGrades: GradeLevel[] = response.data.map(grade => ({
          value: String(grade.id),
          label: grade.name,
          cycles: [],
          schoolTermId: null,
        }))

        setGrades(mappedGrades)
        setError(null)
      } catch (err) {
        console.error('[useArcGrades] Error loading grades:', err)
        setError('Failed to load grades')
      } finally {
        setLoading(false)
      }
    }

    fetchGrades()
  }, [])

  return { grades, loading, error }
}
